import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import EmailIcon from '@mui/icons-material/Email';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import BusinessIcon from '@mui/icons-material/Business';
import SummarizeIcon from '@mui/icons-material/Summarize';

const features = [
  {
    icon: <BusinessIcon sx={{ fontSize: 40 }} />,
    title: 'Multi-Organization',
    description: 'Users see only their org\'s content. Perfect for agencies managing multiple clients.',
  },
  {
    icon: <CloudUploadIcon sx={{ fontSize: 40 }} />,
    title: 'Upload Audio/Video',
    description: 'MP4, MOV, MP3, WAV up to 500MB. Drag and drop or browse to upload.',
  },
  {
    icon: <SmartToyIcon sx={{ fontSize: 40 }} />,
    title: 'Scheduler & Bot Recording',
    description: 'Auto-join Zoom/Teams meetings and record them with our intelligent bot.',
  },
  {
    icon: <EmailIcon sx={{ fontSize: 40 }} />,
    title: 'Email Ingest',
    description: 'Accept meeting invites via email and automatically schedule the bot to join.',
  },
  {
    icon: <CalendarMonthIcon sx={{ fontSize: 40 }} />,
    title: 'Calendar Sync',
    description: 'Sync with Outlook (no admin consent needed) and Google Calendar seamlessly.',
  },
  {
    icon: <SummarizeIcon sx={{ fontSize: 40 }} />,
    title: 'Results UI',
    description: 'View full transcript with AI-generated summary and actionable next steps.',
  },
];

export default function FeatureGrid() {
  return (
    <Box id="features" sx={{ py: 8 }}>
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          component="h2"
          align="center"
          gutterBottom
          sx={{ mb: 6, fontWeight: 700 }}
        >
          Everything You Need
        </Typography>

        <Grid container spacing={4}>
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Paper
                elevation={2}
                sx={{
                  p: 3,
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4,
                  },
                }}
              >
                <Box
                  sx={{
                    color: 'primary.main',
                    mb: 2,
                  }}
                >
                  {feature.icon}
                </Box>
                <Typography
                  variant="h6"
                  component="h3"
                  gutterBottom
                  sx={{ fontWeight: 600 }}
                >
                  {feature.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {feature.description}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
